import React from "react";
import { Flame } from "lucide-react";
import { MENU_ITEMS } from "../data/menu";

function SocialCard({ item }) {
  return (
    <div
      data-testid={`social-card-${item.id}`}
      className="relative w-[540px] h-[540px] overflow-hidden bg-black"
    >
      {/* Food image */}
      <img
        src={item.image}
        alt={item.name}
        className="absolute inset-0 w-full h-full object-cover"
        crossOrigin="anonymous"
      />
      {/* Bottom gradient for text legibility */}
      <div
        className="absolute inset-x-0 bottom-0 h-[60%]"
        style={{
          background:
            "linear-gradient(to top, rgba(0,0,0,0.96) 0%, rgba(0,0,0,0.85) 35%, rgba(0,0,0,0.55) 60%, rgba(0,0,0,0) 100%)",
        }}
      />
      {/* Top ember vignette */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 50% 0%, rgba(255,59,48,0.18), transparent 50%)",
        }}
      />

      {/* Top-right price stamp */}
      <div
        className="absolute top-6 right-6 bg-[#FF3B30] text-white font-['Anton'] tracking-wider px-4 py-2 rotate-3 shadow-[0_8px_24px_rgba(255,59,48,0.5)]"
        style={{ fontSize: 36 }}
      >
        ${item.price}
      </div>

      {/* Top-left brand */}
      <div className="absolute top-6 left-6 flex items-center gap-2">
        <Flame
          className="text-[#FF3B30] drop-shadow-[0_0_10px_rgba(255,59,48,0.7)]"
          style={{ width: 18, height: 18 }}
        />
        <span
          className="font-['Anton'] uppercase text-white tracking-[0.3em]"
          style={{ fontSize: 13 }}
        >
          Smokey <span className="text-[#FF3B30]">AF</span>
        </span>
      </div>

      {/* Bottom content */}
      <div className="absolute inset-x-0 bottom-0 px-8 pb-7 z-10">
        <div className="flex items-center gap-2 mb-2">
          <span className="h-px w-8 bg-[#FF8C00]" />
          <span
            className="font-['Outfit'] uppercase text-[#FF8C00] tracking-[0.4em]"
            style={{ fontSize: 10 }}
          >
            On the Menu
          </span>
        </div>
        <h2
          className="font-['Anton'] uppercase text-white leading-[0.9]"
          style={{ fontSize: 44, letterSpacing: "-0.01em" }}
        >
          {item.name}
        </h2>
        <p
          className="mt-2 font-['Outfit'] italic text-[#FF8C00]"
          style={{ fontSize: 14 }}
        >
          {item.tagline}
        </p>
        <div className="mt-4 flex items-center justify-between">
          <span
            className="font-['Anton'] tracking-widest uppercase bg-white text-black px-3 py-1.5"
            style={{ fontSize: 11 }}
          >
            Order Online
          </span>
          <span
            className="font-['Outfit'] uppercase text-zinc-400 tracking-[0.35em]"
            style={{ fontSize: 9 }}
          >
            smokey-af-bbq.emergent.host
          </span>
        </div>
      </div>
    </div>
  );
}

export default function SocialItems() {
  return (
    <div className="min-h-screen bg-zinc-800 py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <h1 className="font-['Anton'] text-white text-3xl tracking-widest uppercase mb-2">
          Social Posts · 1080×1080
        </h1>
        <p className="font-['Outfit'] text-zinc-400 mb-8 text-sm">
          One square post per menu item, ready to upload to Facebook / Instagram.
          Click a download link below each card.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {MENU_ITEMS.map((item) => (
            <div key={item.id} className="flex flex-col items-center gap-3">
              <SocialCard item={item} />
              <a
                href={`/social/${item.id}.png`}
                download
                data-testid={`social-dl-${item.id}`}
                className="font-['Anton'] text-xs tracking-widest uppercase bg-[#FF3B30] hover:bg-white hover:text-black text-white px-5 py-2.5 transition-colors"
              >
                Download {item.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
